import { PropsWithChildren } from "react"

interface AppContainerContentProps {
    bottomMenu?: React.ReactNode
}
export const AppContainerContent = ({
    children,
    bottomMenu
}: PropsWithChildren<AppContainerContentProps>) => {
    return (
        <div className="app-container-content">
            <div className="app-container-content-top">
                {children}
            </div>
            <div className="app-container-content-bottom">
                {
                    bottomMenu && bottomMenu
                }
            </div>
        </div>
    )
}
